import { Popover, Transition } from "@headlessui/react";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import * as React from "react";
import Button from "../Button/Button";

function InputTime(props) {
  const {
    label,
    error,
    helperText,
    leftElement,
    rightElement,
    registration,
    id,
    width = "w-[120px]",
    height = "h-8",
    placeholder = "시간선택",
    time,
    setTime,
    ...restProps
  } = props;

  const inputProps = {
    id: id,
    ...restProps,
    ...registration,
  };

  const [hour, setHour] = React.useState(time?.split(":")[0] ?? "");
  const [minute, setMinute] = React.useState(time?.split(":")[1] ?? "");

  const onChangeHour = (value) => {
    setHour(value);
  };

  const onChangeMinute = (value) => {
    setMinute(value);
  };

  const onSubmitTime = (onClose) => {
    setTime(`${hour}:${minute}`);
    onClose();
  };

  const hours = Array.from({ length: 24 }).map((_, i) => {
    return {
      id: i < 10 ? `0${i}` : `${i}`,
      name: `${i}시`,
    };
  });

  const minutes = Array.from({ length: 60 }).map((_, i) => {
    return {
      id: i < 10 ? `0${i}` : `${i}`,
      name: `${i}분`,
    };
  });

  // 08시 50분
  const renderedTime = `${time?.split(":")[0]}시 ${time?.split(":")[1]}분`;

  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <Popover.Button className={`${open ? "" : "text-opacity-90"}`}>
            <div className="text-left">
              <input
                id="dateTime"
                type="text"
                value={time}
                placeholder={placeholder}
                className={`hidden relative cursor-pointer text-white border border-button-grey rounded-[4px] p-[6px] focus:outline-none  ${width} ${height}`}
                {...inputProps}
              />
              <label
                htmlFor="dateTime"
                className={`block cursor-pointer border border-button-grey rounded-[4px] p-[6px] focus:outline-none ${width} ${height} ${
                  time ? "text-black" : "text-secondary-grey"
                }`}
              >
                {time ? renderedTime : placeholder}
              </label>
            </div>
          </Popover.Button>
          <Transition
            as={React.Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute left-[90%] mt-1 z-10 w-auto -translate-x-1/2 transform px-4 sm:px-0 ">
              <div className="bg-white overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 p-6">
                <div className="flex justify-between items-center gap-4">
                  <Dropdown
                    width="w-24"
                    options={hours}
                    height="h-10"
                    positionDropdown="top-[4.5rem]"
                    placeholder="시"
                    textColor="text-black px-4"
                    position="fixed"
                    dropdownWidth="w-24"
                    onClickItem={(value) => onChangeHour(value)}
                    defaultValue={time?.split(":")[0]}
                  />
                  <Dropdown
                    width="w-24"
                    options={minutes}
                    height="h-10"
                    positionDropdown="top-[4.5rem]"
                    placeholder="분"
                    textColor="text-black px-4"
                    position="fixed"
                    dropdownWidth="w-24"
                    onClickItem={(value) => onChangeMinute(value)}
                    defaultValue={time?.split(":")[1]}
                  />
                </div>
                <div className="text-[#e80000] my-4">
                  * 발송할 시간을 선택해주세요.
                </div>
                <Button
                  onClick={() => onSubmitTime(close)}
                  primary
                  isDisabled={!hour || !minute}
                  text="선택완료"
                  width="w-full"
                />
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}

export default InputTime;
